import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { BridgeForm } from './form/BridgeForm'
import { useState } from 'react'
import { BridgeViewProps } from '@/features/bridge/logic/types'
import { cn } from '@/ui/utils/style'

export function BridgePanel(props: BridgeViewProps) {
  const { bridge, withHeading } = props
  const [errorMessage, setErrorMessage] = useState<string>('')
  const direction = bridge.swapMode === 'bridgeToHyperEVM' ? 'HyperEVM' : 'HyperCore'

  return (
    <div className="w-full max-w-xl">
      {withHeading && (
        <div className="flex flex-col gap-4 py-4 md:py-6">
          <Typography variant="h1" className="lg:text-4xl" gradient>
            Transfer to {direction}
          </Typography>
          <Typography variant="p" className="mb-7 pb-4 text-white/60">
            This widget uses the official{' '}
            <a
              href="https://hyperliquid.gitbook.io/hyperliquid-docs/for-developers/api/exchange-endpoint"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 underline transition-colors hover:text-white"
            >
              HyperCore transfer API
            </a>
            , and is an easy way to transfer assets between HyperCore and HyperEVM
          </Typography>
        </div>
      )}

      <Panel.Wrapper className={cn('flex flex-col gap-4 p-4 md:p-6', !withHeading && 'p-2 pt-0')}>
        <BridgeForm {...bridge} setErrorMessage={setErrorMessage} />
      </Panel.Wrapper>

      {!!errorMessage && <div className="mt-2 text-center text-red-300 text-sm">{errorMessage}</div>}
    </div>
  )
}
